<template>
  <v-expansion-panels flat accordion multiple :value="[state]" v-model="expanded">
    <v-expansion-panel v-for="(item, i) in serviceList" :key="`about-expandable-${item.id.toString()}`">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(i)"
      >
        <span class="text-tcdc-green header bold">{{ item.title }}</span>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <Service :mode="mode" v-if="parseInt(item.layout) === 1" />
        <News v-if="parseInt(item.layout) === 2" />
        <Partners v-if="parseInt(item.layout) === 3" />
        <SponsorProgram v-if="parseInt(item.layout) === 4" />
        <Network v-if="parseInt(item.layout) === 5" />
        <Location v-if="parseInt(item.layout) === 6 && location && location.branch_id != 5" />
        <Contact v-if="parseInt(item.layout) === 7" />
      </v-expansion-panel-content>
      <Divider />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
import Service from "../../components/about_layout/Service";
import News from "../../components/about_layout/News";
import Partners from "../../components/about_layout/Partners";
import SponsorProgram from "../../components/about_layout/SponsorProgram";
import Network from "../../components/about_layout/Network";
import Location from "../../components/about_layout/Location";
import Contact from "../../components/about_layout/Contact";
import { mapState } from 'vuex';

export default {
  props: {
    items: {
      default: null
    },
    state: {
      default: null
    },
    mode: {
      default: null
    }
  },
  computed: {
    ...mapState({
      location: state => {
        return state.About.location;
      },
      aboutData: state => {
        return {
          network: state.About.network,
          partner: state.About.partner,
          sponsor: state.About.sponsor
        }
      },
      lang: state => state.Branch.lang
    }),
    stateChange: function () {
      return this.state;
    }
  },
  watch: {
    stateChange: function () {
      if (this.stateChange) {
        this.expanded = [];
        if (this.stateChange === 6 && !this.location) {
          this.expanded.push(5)
        } else {
          this.expanded.push(this.stateChange)
        }
      }
    },
    lang: function() {
      this.serviceList = [
        {
          id: "111",
          title: this.$t('service.service'),
          layout: "1"
        },
        {
          id: "112",
          title: this.$t('service.news'),
          layout: "2"
        },
        {
          id: "113",
          title: this.$t('service.partners'),
          layout: "3"
        },
        {
          id: "114",
          title: this.$t('service.sponsor'),
          layout: "4"
        },
        {
          id: "115",
          title: this.$t('service.network'),
          layout: "5"
        },
        {
          id: "116",
          title: this.$t('service.location'),
          layout: "6"
        },
        {
          id: "117",
          title: this.$t('service.contact'),
          layout: "7"
        }
      ];

      if (!this.location) {
        this.serviceList = this.serviceList.filter(s => {
          if (s.title !== this.$t('service.location')) {
            return s;
          }
        });
      }
      if (!this.aboutData.network) {
        this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.network'))
      }

      if (!this.aboutData.sponsor) {
        this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.sponsor'))
      }

      if (!this.aboutData.partner) {
        this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.partners'))
      }
    },
    location: function() {
      if (!this.location) {
        this.serviceList = this.serviceList.filter(s => {
          if (s.title !== this.$t('service.location')) {
            return s;
          }
        });
      } else {
        this.serviceList = [
          {
            id: "111",
            title: this.$t('service.service'),
            layout: "1"
          },
          {
            id: "112",
            title: this.$t('service.news'),
            layout: "2"
          },
          {
            id: "113",
            title: this.$t('service.partners'),
            layout: "3"
          },
          {
            id: "114",
            title: this.$t('service.sponsor'),
            layout: "4"
          },
          {
            id: "115",
            title: this.$t('service.network'),
            layout: "5"
          },
          {
            id: "116",
            title: this.$t('service.location'),
            layout: "6"
          },
          {
            id: "117",
            title: this.$t('service.contact'),
            layout: "7"
          }
        ];
        if (!this.aboutData.network) {
          this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.network'))
        }

        if (!this.aboutData.sponsor) {
          this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.sponsor'))
        }

        if (!this.aboutData.partner) {
          this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.partners'))
        }
      }
    },
    aboutData: function () {
      if (!this.aboutData.network) {
        this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.network'))
      }

      if (!this.aboutData.sponsor) {
        this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.sponsor'))
      }

      if (!this.aboutData.partner) {
        this.serviceList = this.serviceList.filter(x => x.title !== this.$t('service.partners'))
      }
    }
  },
  data: () => ({
    expanded: [],
    serviceList: [
      {
        id: "111",
        title: "บริการ",
        layout: "1"
      },
      {
        id: "112",
        title: "ข่าว",
        layout: "2"
      },
      {
        id: "113",
        title: "หุ้นส่วน",
        layout: "3"
      },
      {
        id: "114",
        title: "ผู้สนับสนุน",
        layout: "4"
      },
      {
        id: "115",
        title: "เครือข่าย",
        layout: "5"
      },
      {
        id: "116",
        title: "สถานที่",
        layout: "6"
      },
      {
        id: "117",
        title: "ติดต่อ",
        layout: "7"
      }
    ]
  }),
  created() {
    if (this.state) {
      if (this.state === 6 && !this.location) {
        this.expanded.push(5)
      } else {
        this.expanded.push(this.state)
      }
    }
    if (!this.location) {
      this.serviceList = this.serviceList.filter(s => {
        if (s.title !== 'location') {
          return s;
        }
      });
    }
  },
  components: {
    Divider,
    Service,
    News,
    Partners,
    SponsorProgram,
    Network,
    Location,
    Contact
  },
  methods: {
    expandHandler(index) {

    }
  }
};
</script>

<style></style>
